import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';

import { Drawer, Typography, IconButton, TextField, Button, Box } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm } from 'react-hook-form';
import { useCreateCategoryMutation } from 'widgets/category/api/getCategoryApi';

type FormDataType = {
  title_kk: string;
  title_ru: string;
  title_kg: string;
  title_uz: string;
  title_en: string;
};

export const DrawerCategory = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const {
    control,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      title_kk: '',
      title_ru: '',
      title_kg: '',
      title_uz: '',
      title_en: '',
    },
  });

  const [createCategoryRequest] = useCreateCategoryMutation();

  const singIn = () => {
    createCategoryRequest({
      title_kk: control._fields.title_kk?._f.value,
      title_ru: control._fields.title_ru?._f.value,
      title_kg: control._fields.title_kg?._f.value,
      title_uz: control._fields.title_uz?._f.value,
      title_en: control._fields.title_en?._f.value,
    }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Новая категория
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Информация о категории</div>
            <Controller
              name="title_kk"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на казахском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_kk && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="title_ru"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на русском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_ru && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="title_kg"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на киргизском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_kg && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="title_uz"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на узбекском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_uz && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="title_en"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на английском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_en && true}
                  {...field}
                />
              )}
            />
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={singIn}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
